import {GeocodingService} from '@/services/google-maps-geocoding/geocoding.service.js'

const geocodingService = new GeocodingService()

export {geocodingService}
